document.addEventListener("DOMContentLoaded", () => {

  const mainBlock = document.querySelector('.buy-buttons-block');
  const stickyCTA = document.querySelector('.sticky-cta-mobile');

  if (!mainBlock || !stickyCTA) return;

  let shopifyChat = null;
  let mainBlockVisible = false;

  function setCommslayerOffset(bubble) {
    if (!bubble) return;

    const isMobile = window.innerWidth <= 767;

    if (!bubble.dataset.originalBottom) {
      bubble.dataset.originalBottom = bubble.style.bottom || '';
    }

    if (isMobile) {
      bubble.style.removeProperty('bottom');
      bubble.classList.add('woot-widget-bubble--offset');
    } else {
      bubble.classList.remove('woot-widget-bubble--offset');
      const originalBottom = bubble.dataset.originalBottom;
      bubble.style.bottom = originalBottom || '10px';
    }
  }

  function initCommslayerOffset() {
    const existingBubble = document.querySelector('.woot-widget-bubble');
    if (existingBubble) {
      setCommslayerOffset(existingBubble);
      return;
    }

    const commslayerObserver = new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.classList.contains('woot-widget-bubble')) {
            setCommslayerOffset(node);
            observer.disconnect();
            return;
          }

          const bubble = node.querySelector?.('.woot-widget-bubble');
          if (bubble) {
            setCommslayerOffset(bubble);
            observer.disconnect();
            return;
          }
        }
      }
    });

    commslayerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initCommslayerOffset();

  function updateStickyCTA(isVisible) {
    if (window.innerWidth >= 768) {
      stickyCTA.classList.remove('is-visible');
      shopifyChat?.classList.remove('hidden');
      return;
    }

    stickyCTA.classList.toggle('is-visible', !isVisible);
    if (shopifyChat) {
      shopifyChat.classList.toggle('hidden', !isVisible);
    }
  }

  const observer = new IntersectionObserver((entries) => {
    mainBlockVisible = entries[0].isIntersecting;
    updateStickyCTA(mainBlockVisible);
  }, { threshold: 0 });

  observer.observe(mainBlock);

  let resizeRafId = null;
  window.addEventListener('resize', () => {
    if (resizeRafId !== null) return;

    resizeRafId = requestAnimationFrame(() => {
      resizeRafId = null;
      updateStickyCTA(mainBlockVisible);

      const bubble = document.querySelector('.woot-widget-bubble');
      if (bubble) {
        setCommslayerOffset(bubble);
      }
    });
  });

  const chatObserver = new MutationObserver(() => {
    const chat = document.getElementById('shopify-chat');
    if (chat) {
      shopifyChat = chat;
      chatObserver.disconnect();
      updateStickyCTA(mainBlockVisible);
    }
  });

  chatObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  const customSelects = document.querySelectorAll(".sticky-variant-custom-select");
  const stickyBtn = document.querySelector(".sticky-add-to-cart-btn");
  const productForm = document.querySelector("form[data-type='add-to-cart-form']");
  const variantInput = productForm?.querySelector("input[name='id']");
  const variantRadios = [...document.querySelectorAll("input[type='radio'][data-variant-id]")];

  customSelects.forEach(select => {
    const trigger = select.querySelector(".custom-select-trigger");
    const options = select.querySelector(".custom-select-options");

    trigger.addEventListener("click", () => {
      options.classList.toggle("hidden");
    });

    options.querySelectorAll("li").forEach(option => {
      option.addEventListener("click", () => {
        if (option.classList.contains("disabled")) return;

        trigger.childNodes[0].textContent = option.textContent;
        options.classList.add("hidden");

        const variantId = option.dataset.variantId;
        variantInput.value = variantId;

        const radio = variantRadios.find(r => r.dataset.variantId === variantId);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }

        options.querySelectorAll("li").forEach(li => li.classList.remove("selected"));
        option.classList.add("selected");
      });
    });

    document.addEventListener("click", (e) => {
      if (!select.contains(e.target)) {
        options.classList.add("hidden");
      }
    });

    variantRadios.forEach(radio => {
      radio.addEventListener("change", () => {
        if (radio.checked && radio.dataset.variantAvailable === "true") {
          trigger.childNodes[0].textContent = radio.nextElementSibling?.textContent || radio.value;

          options.querySelectorAll("li").forEach(li => {
            li.classList.toggle("selected", li.dataset.variantId === radio.dataset.variantId);
          });

          variantInput.value = radio.dataset.variantId;
        }
      });
    });
  });

  stickyBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const select = customSelects[0];
    const selectedOption = select.querySelector("li.selected") || select.querySelector("li:not(.disabled)");
    if (!selectedOption) return alert("This variant is sold out.");

    variantInput.value = selectedOption.dataset.variantId;
    productForm.requestSubmit();
  });

});